let presets = [
	{
		name: "Upcoming 8 Tiles",
		type: "Functionality",
		attributes: [
			{ key: "data-grouped", value: false },
			{ key: "data-calendar", value: false },
			{ key: "data-limit", value: 8 },
			{ key: "data-display-mode", value: "tiles" },
		],
	},
	{
		name: "All Upcoming Tiled",
		type: "Functionality",
		attributes: [
			{ key: "data-grouped", value: true },
			{ key: "data-calendar", value: false },
			{ key: "data-limit", value: undefined },
			{ key: "data-display-mode", value: "tiles" },
		],
	},
	{
		name: "Upcoming 8 List",
		type: "Functionality",
		attributes: [
			{ key: "data-grouped", value: false },
			{ key: "data-calendar", value: false },
			{ key: "data-limit", value: 8 },
			{ key: "data-display-mode", value: "list" },
		],
	},
	{
		name: "All Upcoming List",
		type: "Functionality",
		attributes: [
			{ key: "data-grouped", value: true },
			{ key: "data-calendar", value: false },

			{ key: "data-display-mode", value: "list" },
		],
	},

	{
		name: "Light Mode",
		type: "Style",
		attributes: [
			{ key: "data-modal-color", value: "#FFFFFF" },
			{ key: "data-text-color", value: "#333333" },
		],
	},
	{
		name: "Dark Mode",
		type: "Style",
		attributes: [
			{ key: "data-modal-color", value: "#333333" },
			{ key: "data-text-color", value: "#eeeeee" },
		],
	},
];

export default presets;
